/**
 * Custom (see THEME-EDITS.md): make the whole slideshow slide click through to
 * the same URL as the slide's button, so the hero image is a click target.
 *
 * The click target is the entire slide, not just .slide__media — the theme
 * stacks .slide__content (z-index raised) over the media in the same grid
 * row, so clicks on the image actually land on the content overlay.
 *
 * Uses event delegation so it works with Swiper's cloned slides (loop mode)
 * and slides re-rendered by the theme editor. The link is resolved from the
 * slide's own content at click time, so it always matches the button.
 *
 * Opt-out per section: the "Make slide image clickable" checkbox in the
 * slideshow's settings toggles the data-image-link attribute this script
 * (and the cursor rule in custom.css) keys off.
 */
(() => {
  const findSlide = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return null;
    // Real interactive elements keep their own behavior.
    if (target.closest("a, button, input, select, textarea, label")) return null;
    const slide = target.closest("slideshow-component[data-image-link] .swiper-slide");
    if (!slide) return null;
    // Only image slides — video slides have their own click behavior.
    const media = slide.querySelector(".slide__media");
    if (!media || media.querySelector("video, iframe, deferred-media")) return null;
    return slide;
  };

  const findLink = (slide) =>
    slide.querySelector(".slide__content a.btn[href]") ||
    slide.querySelector(".slide__content a[href]");

  document.addEventListener("click", (event) => {
    if (window.Shopify?.designMode) return; // never navigate inside the theme editor
    const slide = findSlide(event);
    if (!slide) return;

    // Swiper sets allowClick to false when a click ends a drag/swipe.
    const swiper = slide.closest("slideshow-component")?.swiperInstance;
    if (swiper && swiper.allowClick === false) return;

    const link = findLink(slide);
    if (!link) return;

    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      // Respect open-in-new-tab/window modifiers.
      window.open(link.href, "_blank");
    } else {
      // Delegate to the real anchor so page transitions behave normally.
      link.click();
    }
  });

  // Middle-click opens the link in a new tab, like a real anchor.
  document.addEventListener("auxclick", (event) => {
    if (event.button !== 1 || window.Shopify?.designMode) return;
    const slide = findSlide(event);
    if (!slide) return;
    const link = findLink(slide);
    if (link) window.open(link.href, "_blank");
  });
})();
